import React, { useState, useRef } from "react";
import styles from "./Feedback.module.scss";
import { Image } from "semantic-ui-react";
import Axios from "axios";
import Loading from "./Loading/Loading";
import Informer from "./Informer/Informer";
import Cleaning from "./Cleaning";
import Success from "./Success";
import bubble from "../../images/bubble.svg";
import cross from "../../images/crossGray.svg";

export type FormStatus = "Edit" | "Sending" | "Success" | "Error";

export type FeedbackProps = {
  close: () => void;
};

const Feedback = (props: FeedbackProps): JSX.Element => {
  const [formStatus, setFormStatus] = useState<FormStatus>("Edit");
  const [sendDisabled, setSendDisabled] = useState(true);
  const [feedbackLength] = useState(1541);
  const [lengthWarning, setLengthWarning] = useState(false);
  const refFeedbackContent = useRef<HTMLTextAreaElement | null>(null);
  const [feedbackCurrentLength, setFeedbackCurrentLength] = useState(0);

  const isFieldValid = () => {

    if (refFeedbackContent.current) {
      const trueLength = encodeURIComponent(refFeedbackContent.current?.value).length;
      setSendDisabled(refFeedbackContent.current?.value === "" || feedbackLength < trueLength);
      setLengthWarning(feedbackLength < trueLength);
      setFeedbackCurrentLength(trueLength);
    }
  };

  const mailtoFeedback = (feedbackMsg: string) => {
    const subject = "Feedback for KCE Tools 2";
    const toEmail = "ServiceToolsSupport@kone.com";
    const feedback = `Feedback: \n\n${feedbackMsg}\n-------------------------------------------------`;
    const body = encodeURIComponent(feedback);
    window.location.href = `mailto:${toEmail}?subject=${subject}&body=${body}`;
  };

  /**Sending feedback through SMTP server mailer is not used atm, but kept in case it will be */
  const sendFeedback = async (feedbackMsg: string) => {
    setFormStatus("Sending");
    try {
      await Axios.post("http://localhost", { feedback: feedbackMsg }); // Add server endpoint here
      setFormStatus("Success");
      setTimeout(() => props.close(), 3000);
    } catch (e) {
      setFormStatus("Error");
      console.log(e);
    }
  };

  const handleSendFeedbackButton = () => {
    if (refFeedbackContent.current) {
      const feedbackMsg: string = refFeedbackContent.current?.value;
      mailtoFeedback(feedbackMsg);
    }
  };
  const contentSwitcher = () => {
    switch (formStatus) {
      case "Edit":
        return (
          <>
            <div className={styles.headerRow}>
              <div className={styles.Header}>
                <h1>Send us feedback!</h1>
                <Image
                  className={styles.commentIcon}
                  src={bubble}
                  id="feedback"
                  alt="Send feedback icon"
                />
              </div>
              <div onClick={props.close}>
                <Image
                  className={styles.closeIcon}
                  src={cross}
                  id="cancelFeedback"
                  alt="Cancel feedback icon"
                />
              </div>
            </div>
            <div className={styles.info}>
              <p>
                Got a comment, question, suggestion or a bug report? Help us improve KCE Tools 2 by
                letting us know what you think about it.
              </p>
            </div>
            <textarea
              ref={refFeedbackContent}
              style={{ height: "300px" }}
              name="feedback_content"
              onChange={isFieldValid}
              placeholder="Type your feedback here..."
              className={`${styles.textsarea} ${feedbackCurrentLength > 0 ? styles.textAreaNoWarning: ""} ${lengthWarning ? styles.textAreaWarning: ""}`}
            />

            <div className={`${styles.noWarning} ${lengthWarning ? styles.warning: ""}`}>
             <span> {lengthWarning ? "Too many characters!" : ""}</span> <span>{feedbackCurrentLength}/1541</span>
            </div>
            <button disabled={sendDisabled} onClick={handleSendFeedbackButton}>
              SEND
            </button>
          </>
        );
      case "Sending":
        return (
          <>
            <div onClick={props.close}>
              <Image
                className={styles.closeIcon}
                src={cross}
                id="cancelFeedback"
                alt="Cancel feedback icon"
              />
            </div>
            <div className={styles.Center}>
              <Loading text="Sending Feedback..." />;{" "}
            </div>
          </>
        );
      case "Success":
        return (
          <>
            <div onClick={props.close}>
              <Image
                className={styles.closeIcon}
                src={cross}
                id="cancelFeedback"
                alt="Cancel feedback icon"
              />
            </div>
            <div className={styles.Center}>
              <Informer
                icon={<Success height="116px" />}
                title="Thank You!"
                text="Your feedback has been sent."
              />
            </div>
          </>
        );
      case "Error":
        return (
          <>
            <div onClick={props.close}>
              <Image
                className={styles.closeIcon}
                src={cross}
                id="cancelFeedback"
                alt="Cancel feedback icon"
              />
            </div>
            <div className={styles.Center}>
              <Informer
                icon={<Cleaning height="94px" />}
                title="Oh No!"
                text="Something went wrong and your feedback has not been sent. Please, try again in a minute or two."
                button={{ text: "TRY AGAIN", callback: 
                sendFeedback }}
              />
            </div>
          </>
        );

      default:
        return <div>UnKnown Error</div>;
    }
  };

  return <div className={styles.FeedbackOpen}>{contentSwitcher()}</div>;
};

export default Feedback;
